import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import React from 'react'
import { useTranslation } from 'react-i18next';

function ConfirmModal(props) {
    const { openModal, message ,yesHandler, noHandler, yesDisabled, noDisabled} = props;
    const { t } = useTranslation();

    return (
        <>
            <Dialog
                open={openModal}
                disableEscapeKeyDown
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle className='dialog-header'>
                    <div className="title">{t('LBL_CONFIRM')}</div>
                </DialogTitle>

                <DialogContent className='modal-content' dividers>{message}</DialogContent>

                <DialogActions>
                    <Button
                        size="small"
                        onClick={yesHandler}
                        variant={"outlined"}
                        disabled={yesDisabled}
                    >
                        {t("BTN_YES")}
                    </Button>
                    <Button
                        size="small"
                        onClick={noHandler}
                        variant={"outlined"}
                        disabled={noDisabled}
                    >
                        {t("BTN_NO")}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ConfirmModal